import { HttpResponse } from '../http/http-response';

/** @template T */
export class ApiResponse extends HttpResponse {
  mappedItems = null;

  item = null;

  /**
   * @return {T[]}
   */
  getItems() {
    if (this.mappedItems === null && this.requestConfig.dataModel) {
      this.mappedItems = this.getBody().items.map(data => new this.requestConfig.dataModel(data));
    }

    return this.mappedItems === null ? this.getBody().items : this.mappedItems;
  }

  /**
   * @return {T}
   */
  getItem() {
    if (this.item === null && this.requestConfig.dataModel) {
      this.item = new this.requestConfig.dataModel(this.getBody());
    }

    return this.item === null ? this.getBody() : this.item;
  }

  isStatus(code) {
    return this.response.status === code;
  }

  isLastPage() {
    const meta = this.getMeta();
    return meta.total_pages <= meta.page;
  }

  getMeta() {
    return this.getBody()._meta;
  }

  /**
   * @param {String} type
   * @return {Boolean}
   */
  isType(type) {
    return this.getBody().type === type;
  }

  /**
   * @return {String|null}
   */
  getMessage() {
    return this.getBody().message || null;
  }

  /**
   * @return {Object[]}
   */
  getErrors() {
    return this.getBody().errors;
  }

  /**
   * @return {Object[]}
   */
  getErrorsByField() {
    const errors = {};
    this.getErrors().forEach(error => {
      errors[error.field] = error.message;
    });
    return errors;
  }

  /**
   * @return {String|null}
   */
  getFirstValidationErrorMessage() {
    const errors = this.getErrors();
    return errors && typeof errors[0] !== 'undefined' ? errors[0].message : null;
  }

  /**
   * @param {String} field
   * @return {String|null}
   */
  getFieldValidationError(field) {
    const existingError = this.getErrors().find(error => error.field === field);
    if (existingError) {
      return existingError.message;
    }
    return null;
  }

  /**
   * Get the response headers
   * @returns {AxiosResponse<T>.headers|null} the response headers
   */
  getHeaders() {
    return this.response.headers || null;
  }
}
